import { TreeType } from '../markdown.types';

const excludedFromRenderTags = ['text', 'link', 'keyWord', 'email', '@', '[', ']'];

export const renderMarkdownFromTree = (trees: TreeType): string => {
  return trees.reduce((acc, tree) => {
    const content = Array.isArray(tree.content)
      ? renderMarkdownFromTree(tree.content)
      : tree.content;

    if (!excludedFromRenderTags.includes(tree.tag)) {
      return acc + `${tree.tag}${content}${tree.tag}`;
    } else {
      if (tree.tag === '[' && tree.props?.link) {
        return acc + `[${content}](${tree.props.link})`;
      }
      return acc + content;
    }
  }, '');
};
